// extracted by mini-css-extract-plugin
export var callCard = "_ia-0";
export var callMessageButton = "_ia-1";
export var helpIcon = "_ia-3";
export var helpIconContainer = "_ia-4";
export var verticalDivider = "_ia-2";